import type { FC } from "react";

import { Column } from "@aviary";
import { SvgCarbonZeroLogo, SvgHipaaLogo } from "@shared/assets/images";
import { useGlobalConfig } from "@shared/context";

import * as styles from "./FooterLogos.styles";

const FooterLogos: FC = () => {
  const { isUS } = useGlobalConfig();

  return (
    <Column>
      <SvgCarbonZeroLogo />
      {isUS && <SvgHipaaLogo css={styles.spacingLeft} />}
    </Column>
  );
};

export { FooterLogos };
